/*
 * bk-vd-sync.js
 * Brueckt die Vitals "UB Volume Discounts"-Tiers (.bk-vd) mit dem eigenen
 * Buy-Box-Stepper (input[name="quantity"] in .bk-stepper).
 *
 * Verhalten:
 *  - Forward: Tier waehlen (Kaufe 2/3/4) → Stepper-Menge springt auf die Anzahl.
 *  - Reverse (nur UI): Stepper manuell aendern (+/-/tippen) → das passende Tier
 *    wird optisch angehakt. Keine Vitals-Cart-Logik wird dabei ausgeloest.
 *  - Pro-Stueck-Variantendropdowns (#1/#2/…) werden ausgeblendet: die Variante
 *    kommt aus den Buy-Box-Kacheln, der Rabatt gilt immer fuer die gewaehlte
 *    Variante; die Menge kommt aus dem Tier/Stepper.
 *
 * Der normale Theme-CTA legt die Menge der gewaehlten Variante in den Warenkorb,
 * der Mengen-Rabatt greift automatisch (Shopify-Automatik-Rabatt).
 *
 * Robust gebaut, weil Vitals den Block asynchron rendert, das Radio readonly /
 * klassengesteuert ist (kein verlaesslicher 'change'-Event) und bei
 * Variantenwechsel neu rendert: ein MutationObserver auf .bk-vd haelt Forward-Sync
 * + Dropdown-Hide am Laufen.
 */
(function () {
  var TIER = '.Vtl-VolumeDiscountRadio__TierItem';

  function bkVdInit(section) {
    if (section.__bkVdInit) return;
    var vd = section.querySelector('.bk-vd');
    var stepper = section.querySelector('[data-bk-stepper] .bk-stepper__input');
    if (!vd || !stepper) return;
    section.__bkVdInit = true;

    var syncing = false; // Guard gegen Forward/Reverse-Echo

    // Sane-Range-Guard: Vitals' radio.value kann eine Offer-/Varianten-ID sein,
    // KEINE Menge → solche Kandidaten verwerfen, nur 1..99 akzeptieren.
    function asQty(raw) {
      var n = parseInt(raw, 10);
      return n >= 1 && n <= 99 ? n : null;
    }

    function tierQuantity(tier) {
      if (!tier) return null;
      var radio = tier.querySelector('input[type="radio"]');
      var q = asQty(tier.getAttribute('data-quantity'))
        || asQty(radio && radio.getAttribute('data-quantity'));
      if (q) return q;
      var m = (tier.textContent || '').match(/\d+/);
      return (m && asQty(m[0])) || 1;
    }

    function tiers() {
      return Array.prototype.slice.call(vd.querySelectorAll(TIER));
    }

    function selectedTier() {
      var sel = vd.querySelector(TIER + '--Selected');
      if (sel) return sel;
      var checked = vd.querySelector('input[type="radio"]:checked');
      return checked ? checked.closest(TIER) : null;
    }

    // --- Pro-Stueck-Variantendropdowns ausblenden (klassenagnostisch) ---
    // Vom <select> hoch bis zum direkten Kind des Tier-Items (bzw. Widgets)
    // klettern und diese ganze Reihe ausblenden (nimmt das "#n"-Label mit).
    function hidePickers() {
      vd.querySelectorAll('select').forEach(function (sel) {
        var row = sel;
        while (
          row.parentElement &&
          row.parentElement !== vd &&
          !/TierItem/.test(row.parentElement.className || '')
        ) {
          row = row.parentElement;
        }
        if (row !== vd) row.style.setProperty('display', 'none', 'important');
      });
    }

    // --- Forward: Vitals-Auswahl → Stepper-Menge ---
    function syncStepperFromTier() {
      var q = tierQuantity(selectedTier());
      if (q && String(q) !== String(stepper.value)) {
        syncing = true;
        stepper.value = q;
        // bubbles:false → erreicht NUR die direkten Stepper-Listener (Klemmung),
        // nicht Vitals' Document-Listener.
        stepper.dispatchEvent(new Event('change', { bubbles: false }));
        syncing = false;
      }
    }

    // --- Reverse (nur UI): Stepper-Menge → passendes Tier optisch anhaken ---
    function syncTierFromStepper() {
      if (syncing) return;
      var q = asQty(stepper.value);
      var list = tiers();
      if (!list.length) return;
      var match = null;
      list.forEach(function (t) { if (tierQuantity(t) === q) match = t; });
      syncing = true;
      list.forEach(function (t) {
        var on = t === match;
        var radio = t.querySelector('input[type="radio"]');
        if (radio) radio.checked = on; // setzt kein change-Event → kein Vitals-Trigger
        t.classList.toggle('Vtl-VolumeDiscountRadio__TierItem--Selected', on);
        t.classList.toggle('Vtl-VolumeDiscountRadio__TierItem--NotSelected', !on);
      });
      syncing = false;
    }

    if ('MutationObserver' in window) {
      var mo = new MutationObserver(function () {
        if (syncing) return;
        hidePickers();
        syncStepperFromTier();
      });
      mo.observe(vd, {
        childList: true,
        subtree: true,
        attributes: true,
        attributeFilter: ['class']
      });
    }

    // Klick auf eine Tier-Reihe (Radio kann readonly sein) → Forward-Sync.
    vd.addEventListener('click', function (e) {
      if (e.target.closest(TIER)) window.setTimeout(syncStepperFromTier, 0);
    });

    // Stepper manuell geaendert → Reverse-Sync (nur UI).
    stepper.addEventListener('change', syncTierFromStepper);
    stepper.addEventListener('input', syncTierFromStepper);

    // Erst-Durchlauf (sonst uebernimmt der Observer, sobald Vitals rendert).
    hidePickers();
    syncStepperFromTier();
  }

  function boot() {
    document.querySelectorAll('.bk-product-section').forEach(bkVdInit);
  }
  if (document.readyState !== 'loading') boot();
  else document.addEventListener('DOMContentLoaded', boot);
  document.addEventListener('shopify:section:load', boot);
})();
